export default __webpack_public_path__ + "static/media/PAG.0ef475e5.svg";